module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-BoldItalic.cb8500d.woff";